import StatsGrid from "../dashboard/StatsGrid";

function TotalCallsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}

function BookingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
      <line x1="16" x2="16" y1="2" y2="6" />
      <line x1="8" x2="8" y1="2" y2="6" />
      <line x1="3" x2="21" y1="10" y2="10" />
      <path d="m9 16 2 2 4-4" />
    </svg>
  );
}

function ClockIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

function TrendIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
      <polyline points="16 7 22 7 22 13" />
    </svg>
  );
}

function buildCards(counts = {}) {
  return [
    {
      key: "pending-calls",
      label: "Pending Calls",
      value: Number(counts.pending_calls || 0),
      sub: "Waiting for follow-up",
      tone: "gold",
      icon: <ClockIcon />,
    },
    {
      key: "assigned-calls",
      label: "Assigned Calls",
      value: Number(counts.assigned_calls || 0),
      sub: "Active work in progress",
      tone: "blue",
      icon: <TotalCallsIcon />,
    },
    {
      key: "completed-followups",
      label: "Completed Follow-ups",
      value: Number(counts.completed_followups || 0),
      sub: Number(counts.today_completed || 0)
        ? `${Number(counts.today_completed || 0)} completed today`
        : "No completions today",
      tone: "green",
      icon: <BookingIcon />,
    },
    {
      key: "callback-required",
      label: "Callback Required",
      value: Number(counts.callback_required || 0),
      sub: "Need another touchpoint",
      tone: "amber",
      icon: <TrendIcon />,
    },
  ];
}

export default function CallingAgentSummaryGrid({ counts }) {
  return <StatsGrid cards={buildCards(counts)} />;
}
